<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/hWD2VE/tc-custom/9781446379554.jpg?1705148600525" alt="This image is the cover for the book Macraweave"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Macraweave
      </h1>
      <p class="bookDescription body article font2">
        <b>Discover the exciting new craft that brings together two timelessly popular fiber arts to make beautiful, eye-catching pieces for your home.</b><br/>  <br/> Learn to create stunning woven wall hangings and inject a dose of “bohemian luxe” to your living space. <i>Macraweave</i>combines the crafts of macramé knotting with weaving to create eye-catching projects that really pop with texture and color. <br/>  <br/> There are eighteen projects to choose from including woven wall hangings, table mats, plant hangers and cushions as well as accessories such as jewelry. All the instructions and projects are illustrated with step-by-step photography. 
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Amy Mullins, Marnia Ryan-Raison
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      A David and Charles Book
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2bb891b4